import script from "./ContractListView.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractListView.vue?vue&type=script&setup=true&lang=js"

import "./ContractListView.vue?vue&type=style&index=0&id=8b5cd264&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b5cd264"]])

export default __exports__